import autobind from 'autobind-decorator';
import { computed, extendObservable, toJS } from 'mobx';

@autobind
class TeamGameStatModel {
  constructor(data) {
    extendObservable(this, data);
  }
  @computed
  get chart() {
    const {
      fieldGoalsPercentage,
      threePointFieldGoalsPercentage,
      freeThrowsPercentage,
      assists,
      reboundsTotal,
      steals,
      blockedShots,
      turnoversTotal
    } = this;

    let result = {
      fieldGoalsPercentage: { p: 0, v: '' },
      threePointFieldGoalsPercentage: { p: 0, v: '' },
      freeThrowsPercentage: { p: 0, v: '' },
      assists: { p: 0, v: '' },
      reboundsTotal: { p: 0, v: '' },
      steals: { p: 0, v: '' },
      blockedShots: { p: 0, v: '' },
      turnoversTotal: { p: 0, v: '' }
    };

    // 득점, 실점 - 150을 기준으로 150이상시 100% 고정 득점은 높은 팀이 빨간색, 실점은 낮은팀이 빨간색
    // 야투, 3점슛, 자유투 - 100%를 기준으로 높은 팀이 빨간색
    // 어시스트 - 30을 기준으로 30이상일 경우 100% 고정 높은게 빨간색
    // 리바운드 50을 기준으로 50이상일 경우 100% 고정 높은게 빨간색
    // 스틸, 블록 - 10을 기준으로 10이상일 경우 100% 고정 높은게 빨간색
    // 턴오버 - 30을 기준으로 30이상일 경우 100% 고정 낮은숫자가 빨간색

    // 야투
    if (!!fieldGoalsPercentage) {
      result.fieldGoalsPercentage = {
        p: fieldGoalsPercentage > 100 ? 100 : fieldGoalsPercentage,
        v: `${Math.floor(+fieldGoalsPercentage)}%`
      };
    }

    // 3점슛
    if (!!threePointFieldGoalsPercentage) {
      result.threePointFieldGoalsPercentage = {
        p:
          threePointFieldGoalsPercentage > 100
            ? 100
            : threePointFieldGoalsPercentage,
        v: `${Math.floor(threePointFieldGoalsPercentage)}%`
      };
    }

    // 자유투
    if (!!freeThrowsPercentage) {
      result.freeThrowsPercentage = {
        p: freeThrowsPercentage > 100 ? 100 : freeThrowsPercentage,
        v: `${Math.floor(+freeThrowsPercentage)}%`
      };
    }

    //  어시스트
    if (!!assists) {
      const value = +((assists / 30) * 100).toFixed(1);

      result.assists = {
        p: value > 100 ? 100 : value,
        v: assists
      };
    }

    //  리바운드
    if (!!reboundsTotal) {
      const value = +((reboundsTotal / 50) * 100).toFixed(1);

      result.reboundsTotal = {
        p: value > 100 ? 100 : value,
        v: reboundsTotal
      };
    }

    //  스틸
    if (!!steals) {
      const value = +((steals / 10) * 100).toFixed(1);

      result.steals = {
        p: value > 100 ? 100 : value,
        v: steals
      };
    }

    //  블록
    if (!!blockedShots) {
      const value = +((blockedShots / 10) * 100).toFixed(1);

      result.blockedShots = {
        p: value > 100 ? 100 : value,
        v: blockedShots
      };
    }

    //  턴오버
    if (!!turnoversTotal) {
      const value = +((turnoversTotal / 30) * 100).toFixed(1);

      result.turnoversTotal = {
        p: value > 100 ? 100 : value,
        v: turnoversTotal
      };
    }

    return result;
  }
}

export default TeamGameStatModel;
